import { SphereIconButton } from "@components/common/sphere-icon-button";
import { EditIcon, neutral } from "@flat-ui";
import { IconButtonProps } from "@mui/material";

interface Props {
  /** Optional props to be forwarded to the IconButton element. */
  iconButtonProps?: IconButtonProps;

  /** Triggered when the users clicks on the button. */
  onClick: () => void;
}

/** Icon button with edit icon, used in table cells to indicate the edit action on hover */
export function EditColumnValueIcon({
  iconButtonProps,
  onClick,
}: Props): JSX.Element {
  return (
    <SphereIconButton
      component={EditIcon}
      buttonSize="24px"
      iconSize="16px"
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
      color={neutral[400]}
      iconButtonProps={{
        ...iconButtonProps,
        sx: { visibility: "hidden" },
      }}
    />
  );
}
